var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPoggi = function SvgPoggi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4916_855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint0_linear_4916_855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.99982L24.6942 18.2916H33.4127L26.3593 23.4162L29.0534 31.708L22 26.5834L14.9466 31.708L17.6407 23.4162L10.5873 18.2916H19.3058L22 9.99982Z",
    fill: "#402F18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_855",
    x1: 2,
    y1: -0.00000110418,
    x2: 42,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86764F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCBA7C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4916_855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPoggi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/poggi.15c8e404.svg";
export { ForwardRef as ReactComponent };